module.exports = __webpack_public_path__ + "static/media/Alianqiu.60c52ce5.svg";